import { Controller } from "react-hook-form";
import { TextArea } from "devextreme-react";
import { Input, InputProps } from "..";

const InputTextArea = ({
  control,
  errors,
  name,
  label,
  mask,
  height,
  width,
  required,
  disabled = false,
  onValueChanged = () => {},
  maxLength,
  tabIndex,
  direction,
  placeHolder,
}: InputProps) => {
  return (
    <Input
      type="textarea"
      direction={direction ? direction : `row`}
      label={label && label}
      required={required}
      errors={errors && errors}
    >
      <Controller
        render={({ field: { onChange, value } }) => {
          if (value === "") value = null;

          return (
            <TextArea
              mask={mask}
              useMaskedValue={true}
              onValueChanged={(value) => {
                onChange(value.value);
                onValueChanged(value);
              }}
              value={value}
              disabled={disabled}
              height={height}
              width={width}
              maxLength={maxLength}
              tabIndex={tabIndex}
              defaultValue={null}
              placeholder={placeHolder}
            />
          );
        }}
        control={control}
        name={name}
        defaultValue={null}
      />
    </Input>
  );
};

export default InputTextArea;
